<template>
  <div class="app-body">
        <el-form
          :inline="true"
          :model="queryForm"
          @keyup.enter.native="getDataList()"
          ref="queryForm"
          class="query-form"
        >
          <el-form-item prop="name" label="供应商名称：">
            <el-input
              v-model="queryForm.name"
              size="mini"
              clearable
              type="text"
              placeholder="请输入供应商名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDataList" size="mini"
              >查询</el-button
            >
            <el-button @click="reset" size="mini">重置</el-button>
            <el-button
              size="mini"
              v-if="$hasPermission('trade:company:save')"
              type="primary"
              @click="addOrUpdateHandle()"
              >{{ $t("add") }}
            </el-button>
          </el-form-item>
        </el-form>
    <SweetTable ref="table" api-version="v2" url="/erp/company/page"  delete-url="/erp/company" :query-form="queryForm" :before-table-binding="beforeTableBinding">
      <el-table-column prop="name" label="供应商名称" align="center" header-align="center" width="240">
        <template #default="{ row }">
          <div class="flex" style="align-items: center">
            <el-tag size="mini" v-if="row.storageId">仓库</el-tag>
            <el-tag v-else type="danger">无仓库</el-tag>
            <el-button type="text" size="mini" @click="showAmountFlowDialog(row)" style="margin-left: 4px;">{{row.name}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="categoryKey" label="类型" align="center" header-align="center" width="80"></el-table-column>
      <el-table-column prop="province" label="省份" align="center" header-align="center" width="80"> </el-table-column>
      <el-table-column label="开票信息" >
        <template #default="{ row }">
          <div class="flex" v-for="item in row.receiptList" :key="item.id">
            <div style="text-align: left">开户行：{{ item.accountName }}</div>
            <div style="margin-left: 20px; text-align: left">
              银行账号：{{ item.taxCode }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" > </el-table-column>
      <el-table-column label="操作" align="center" header-align="center" width="240" fixed="right">
        <template #default="{ row }">
          <el-button
              v-if="$hasPermission('trade:company:update')"
              type="text"
              size="small"
              @click="showContact(row)"
              icon="el-icon-edit-outline"
          >查看联系人
          </el-button>
          <el-button
            v-if="$hasPermission('trade:company:update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(row.id)"
            icon="el-icon-edit-outline"
            >{{ $t("update") }}
          </el-button>
          <el-button
            v-if="$hasPermission('trade:company:delete')"
            type="text"
            size="small"
            icon="el-icon-close"
            @click="doDelete(row)"
            >{{ $t("delete") }}
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>

    <add-or-update
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
    <amount-flow-dialog ref="AmountFlowDialog"></amount-flow-dialog>
    <account-dialog ref="AccountDialog"></account-dialog>
    <contact ref="Contact"></contact>
    <common-upload
        ref="uploader"
        uploadUrl="/trade/company/contact/import"
        label=""
    ></common-upload>
</div>
</template>

<script>
import Contact from '@/views/modules/trade/company/contact'
import AccountDialog from './account/index'
import AddOrUpdate from "./add-or-update";
import AmountFlowDialog from '@/views/modules/trade/company/amount-flow-dialog'
import SweetTable from '@/mixins/SweetTable'
export default {
  mixins: [SweetTable],
  components: {
    AddOrUpdate,AmountFlowDialog,AccountDialog,Contact
  },
  data() {
    return {
      queryForm: {
        name: "",
      },
    };
  },
  methods: {
    //显示联系人弹窗
    showContact(row){
      this.$refs.Contact.init(row.id)
    },
    showAccountDialog(row){
      this.$refs.AccountDialog.init(row.id)
    },
    showAmountFlowDialog(row){
      this.$refs.AmountFlowDialog.init(row.id,row.name)
    },
    createStorages() {
      const loading = this.$loading();
      this.$http
        .post(`/trade/company/create/storage`, this.dataListSelections)
        .then(({ data: res }) => {
          loading.close();
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.reload();
          this.$message.success("操作成功");
        })
        .catch((e) => {
          loading.close();
          console.log(e);
        });
    },
    beforeTableBinding(dataList) {
      if (!dataList || dataList.length == 0) {
        return;
      }
      dataList.forEach((row) => {
        if (row.category) {
          row.category = row.category.split(",");
        }
        if (row.remark) {
          try {
            let ro = JSON.parse(row.remark);
            row.remark = ro.join(",");
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
    showUploadDialog() {
      this.$refs.uploader.init();
    },
    reset() {
      this.$refs.queryForm.resetFields();
      this.queryForm = {
        name: "",
      }
      this.getDataList();
    }
  },
};
</script>
